import * as tslib_1 from "tslib";
import { Component, Vue, Prop } from "vue-property-decorator";
let RichText = class RichText extends Vue {
    render(h) {
        return h('a-textarea', { props: {
                disabled: true,
                placeholder: "请输入"
            } });
    }
};
tslib_1.__decorate([
    Prop()
], RichText.prototype, "control", void 0);
RichText = tslib_1.__decorate([
    Component({ name: "RichText" })
], RichText);
export default RichText;
